import { isNil } from 'ramda';

import { PremiumPay } from '../types';

export const isSvcTypeBonus = (
  bonusTypeSvc: PremiumPay['bonusTypeSvcName'] | undefined
) => bonusTypeSvc && bonusTypeSvc.startsWith('bonus');

export const mapToOptions = (
  arr: { [key: string]: any }[] | undefined,
  optionValueGetter: string,
  optionLabelGetter: string
) => {
  if (isNil(arr)) {
    return [];
  }
  return arr.map((item) => ({
    value: item[optionValueGetter],
    label: item[optionLabelGetter]
  }));
};
